import EmailList from './index';
import Task from './detail/task';
import Detail from './detail/detail';

export default {
    path: '/home/batch/email',
    component: EmailList,
    redirect: '/home/batch/email/task',
    children: [
        {path: '/home/batch/email/task', component: Task},
        {path: '/home/batch/email/detail', component: Detail}
    ]
}

